import React, { FC } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { AnimatedLayoutContainer } from "@/views/components/Layout";
import { router } from "@/views/router";

import { ConfirmEmail } from "./components";

interface ISessionSignUpEmailVerifyProps {}

export const SessionSignUpEmailVerify: FC<ISessionSignUpEmailVerifyProps> = ({}) => {
  const location = useLocation<any>();
  const history = useHistory();
  const email = location.state?.email;

  if (!email) {
    history.push(router.get("public-job-requests").path);
  }

  return (
    <AnimatedLayoutContainer size="md" showLogo>
      <ConfirmEmail email={email} />
    </AnimatedLayoutContainer>
  );
};
